// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchCircleFilledSvg from "@fishx/icons-svg/es/asn/SketchCircleFilled";
import FishxIcon from '../components/FishxIcon';

var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchCircleFilledSvg
  }));
};

SketchCircleFilled.displayName = 'SketchCircleFilled';
export default React.forwardRef(SketchCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SketchCircleFilled.js
// module id = 4119
// module chunks = 0